module.exports = __webpack_public_path__ + "static/media/finance_active.c287eb9f.svg";